export default __webpack_public_path__ + "locales/uk-UA/ConnectDialog.json?hash=3222b36204529ed0254214a1b269dc30";